var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8046_6416)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8046_6416",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8046_6416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0911 0.61084H1.91078C1.74189 0.61084 1.60547 0.747257 1.60547 0.916155V4.9069C1.60547 5.0758 1.74189 5.21221 1.91078 5.21221H9.08893C9.25783 5.21221 9.39425 5.0758 9.39425 4.9069V0.916155C9.39641 0.749422 9.25783 0.61084 9.0911 0.61084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09138 0H1.91106C1.40653 0 0.995117 0.411417 0.995117 0.915945V4.90669C0.995117 5.41122 1.40653 5.82264 1.91106 5.82264H9.08921C9.59374 5.82264 10.0052 5.41122 10.0052 4.90669V0.915945C10.0073 0.411417 9.5959 0 9.09138 0ZM9.39669 4.90669C9.39669 5.07559 9.26027 5.21201 9.09138 5.21201H1.91106C1.74216 5.21201 1.60575 5.07559 1.60575 4.90669V0.915945C1.60575 0.747047 1.74216 0.61063 1.91106 0.61063H9.08921C9.25811 0.61063 9.39453 0.747047 9.39453 0.915945V4.90669H9.39669Z",
    fill: "url(#paint0_linear_8046_6416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47851 1.22119H2.52379C2.35489 1.22119 2.21847 1.35761 2.21847 1.52651V2.02887H3.35095C3.51985 2.02887 3.65627 2.16529 3.65627 2.33418C3.65627 2.50308 3.51985 2.6395 3.35095 2.6395H2.21847V3.183H2.7728C2.9417 3.183 3.07812 3.31942 3.07812 3.48832C3.07812 3.65722 2.9417 3.79363 2.7728 3.79363H2.21631V4.296C2.21631 4.46489 2.35273 4.60131 2.52162 4.60131H8.47851C8.64741 4.60131 8.78383 4.46489 8.78383 4.296V1.52867C8.78599 1.35978 8.64741 1.22119 8.47851 1.22119Z",
    fill: "url(#paint1_linear_8046_6416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2209 7.8883C3.46992 7.8883 3.6713 7.68693 3.6713 7.43791C3.6713 7.1889 3.46775 6.98535 3.2209 6.98535C2.97405 6.98535 2.77051 7.1889 2.77051 7.43791C2.77051 7.68693 2.97189 7.8883 3.2209 7.8883Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85129 9.39746L3.48751 10.0406C3.37058 10.2484 3.07176 10.2484 2.95483 10.0406L2.59105 9.39746C2.19479 9.59018 1.90463 9.96046 1.81152 10.3892H4.63081C4.5377 9.95829 4.24755 9.59018 3.85129 9.39746Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41574 9.39746L8.05196 10.0427C7.93503 10.2506 7.63621 10.2506 7.51928 10.0427L7.1555 9.39746C6.75924 9.59018 6.46909 9.96046 6.37598 10.3892H9.19527C9.09999 9.95829 8.812 9.59018 8.41574 9.39746Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28409 7.43575C4.28409 6.84894 3.80771 6.37256 3.2209 6.37256C2.63409 6.37256 2.15771 6.84894 2.15771 7.43575C2.15771 8.02256 2.63409 8.49894 3.2209 8.49894C3.80771 8.49894 4.28409 8.02256 4.28409 7.43575ZM3.2209 6.98536C3.46992 6.98536 3.6713 7.1889 3.6713 7.43791C3.6713 7.68693 3.46775 7.88831 3.2209 7.88831C2.97405 7.88831 2.77051 7.68693 2.77051 7.43791C2.77051 7.1889 2.97189 6.98536 3.2209 6.98536Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79909 8.72424C3.66267 8.6831 3.51542 8.74373 3.44613 8.86715L3.22094 9.26991L2.99574 8.86715C2.92645 8.74373 2.7792 8.6831 2.64279 8.72424C1.77448 8.97975 1.16602 9.7896 1.16602 10.6948C1.16602 10.8637 1.30243 11.0001 1.47133 11.0001H4.96838C5.13728 11.0001 5.27369 10.8637 5.27369 10.6948C5.27586 9.7896 4.66956 8.97975 3.79909 8.72424ZM1.81129 10.3894C1.90657 9.96066 2.19456 9.59038 2.59082 9.39767L2.9546 10.043C3.07153 10.2509 3.37035 10.2509 3.48728 10.043L3.85106 9.39767C4.24731 9.59038 4.53747 9.96066 4.63058 10.3894H1.81129Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36375 8.72424C8.22733 8.6831 8.08009 8.74373 8.0108 8.86715L7.7856 9.26991L7.55824 8.86715C7.48895 8.74373 7.3417 8.6831 7.20529 8.72424C6.33698 8.97975 5.72852 9.7896 5.72852 10.6948C5.72852 10.8637 5.86493 11.0001 6.03383 11.0001H9.53088C9.69978 11.0001 9.83619 10.8637 9.83619 10.6948C9.84052 9.7896 9.23206 8.97975 8.36375 8.72424ZM6.37596 10.3894C6.47123 9.96066 6.75922 9.59038 7.15548 9.39767L7.51926 10.043C7.63619 10.2509 7.93501 10.2509 8.05194 10.043L8.41572 9.39767C8.81198 9.59038 9.10214 9.96066 9.19525 10.3894H6.37596Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84415 7.43575C8.84415 6.84894 8.36777 6.37256 7.78096 6.37256C7.19415 6.37256 6.71777 6.84894 6.71777 7.43575C6.71777 8.02256 7.19415 8.49894 7.78096 8.49894C8.36777 8.49894 8.84415 8.02256 8.84415 7.43575ZM7.3284 7.43575C7.3284 7.18673 7.53195 6.98319 7.78096 6.98319C8.02998 6.98319 8.23136 7.18673 8.23136 7.43575C8.23136 7.68476 8.02998 7.88614 7.78096 7.88614C7.53195 7.88614 7.3284 7.68476 7.3284 7.43575Z",
    fill: "#C4C4C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6416",
    x1: 5.50016,
    y1: 0,
    x2: 5.50016,
    y2: 5.82264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6416",
    x1: 5.50008,
    y1: 1.22119,
    x2: 5.50008,
    y2: 4.60131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8046_6416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWorkspace);
export default __webpack_public_path__ + "static/media/Menu-Workspace.68e418b07d4906751bf38a68e0f1da79.svg";
export { ForwardRef as ReactComponent };